import { useState } from 'react';
import StudentSidebar from '../components/sidebar/StudentSlidebar';
import StudentNav from '../components/adminNav/StudentNav';
const StudentWrapper = ({ children, searchBar }) => {
  const [side, setSide] = useState('-left-64 md:left-0');

  console.log(side);
  const openSidebar = () => {
    setSide('left-0 md:-left-64');
  };
  const closeSidebar = () => {
    setSide('-left-64 md:left-0');
  };

  return (
    <>
      <StudentSidebar side={side} closeSidebar={closeSidebar} />
      <StudentNav
        searchBar={searchBar}
        openSidebar={openSidebar}
        closeSidebar={closeSidebar}
        side={side}
      />
      <section
        className={`ml-0 ${
          side === 'left-0 md:-left-64' ? 'ml-0 ' : 'ml-0 md:ml-64'
        }   min-h-screen pt-24 px-4`}
      >
        <div className=" text-black md:px-4 px-0 py-6">{children}</div>
      </section>
    </>
  );
};
export default StudentWrapper;
